import { toast } from 'react-toastify';

export const handleFetchError = (error: any) => {
  if (error && error.status !== 401) {
    toast.error(error?.data?.message || 'Something went wrong');
  }
};
